
// @ts-nocheck


export const localeCodes =  [
  "ko",
  "ja",
  "zh-hant",
  "en",
  "es",
  "zh-CN",
  "it",
  "ru",
  "vi",
  "id",
  "km",
  "hi",
  "th",
  "fr",
  "ar"
]

export const localeLoaders = {
  "ko": [{ key: "../src/locales/ko_KR.json", load: () => import("../src/locales/ko_KR.json" /* webpackChunkName: "locale__app_src_locales_ko_KR_json" */), cache: true }],
  "ja": [{ key: "../src/locales/ja_JP.json", load: () => import("../src/locales/ja_JP.json" /* webpackChunkName: "locale__app_src_locales_ja_JP_json" */), cache: true }],
  "zh-hant": [{ key: "../src/locales/zh_TW.json", load: () => import("../src/locales/zh_TW.json" /* webpackChunkName: "locale__app_src_locales_zh_TW_json" */), cache: true }],
  "en": [{ key: "../src/locales/en_US.json", load: () => import("../src/locales/en_US.json" /* webpackChunkName: "locale__app_src_locales_en_US_json" */), cache: true }],
  "es": [{ key: "../src/locales/es_ES.json", load: () => import("../src/locales/es_ES.json" /* webpackChunkName: "locale__app_src_locales_es_ES_json" */), cache: true }],
  "zh-CN": [{ key: "../src/locales/zh_CN.json", load: () => import("../src/locales/zh_CN.json" /* webpackChunkName: "locale__app_src_locales_zh_CN_json" */), cache: true }],
  "it": [{ key: "../src/locales/it_IT.json", load: () => import("../src/locales/it_IT.json" /* webpackChunkName: "locale__app_src_locales_it_IT_json" */), cache: true }],
  "ru": [{ key: "../src/locales/ru_RU.json", load: () => import("../src/locales/ru_RU.json" /* webpackChunkName: "locale__app_src_locales_ru_RU_json" */), cache: true }],
  "vi": [{ key: "../src/locales/vi_VN.json", load: () => import("../src/locales/vi_VN.json" /* webpackChunkName: "locale__app_src_locales_vi_VN_json" */), cache: true }],
  "id": [{ key: "../src/locales/id_ID.json", load: () => import("../src/locales/id_ID.json" /* webpackChunkName: "locale__app_src_locales_id_ID_json" */), cache: true }],
  "km": [{ key: "../src/locales/km_KH.json", load: () => import("../src/locales/km_KH.json" /* webpackChunkName: "locale__app_src_locales_km_KH_json" */), cache: true }],
  "hi": [{ key: "../src/locales/hi_IN.json", load: () => import("../src/locales/hi_IN.json" /* webpackChunkName: "locale__app_src_locales_hi_IN_json" */), cache: true }],
  "th": [{ key: "../src/locales/th_TH.json", load: () => import("../src/locales/th_TH.json" /* webpackChunkName: "locale__app_src_locales_th_TH_json" */), cache: true }],
  "fr": [{ key: "../src/locales/fr_FR.json", load: () => import("../src/locales/fr_FR.json" /* webpackChunkName: "locale__app_src_locales_fr_FR_json" */), cache: true }],
  "ar": [{ key: "../src/locales/ar_SA.json", load: () => import("../src/locales/ar_SA.json" /* webpackChunkName: "locale__app_src_locales_ar_SA_json" */), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": false,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "ko",
      "language": "ko",
      "files": [
        "/app/src/locales/ko_KR.json"
      ]
    },
    {
      "code": "ja",
      "language": "ja",
      "files": [
        "/app/src/locales/ja_JP.json"
      ]
    },
    {
      "code": "zh-hant",
      "language": "zh",
      "files": [
        "/app/src/locales/zh_TW.json"
      ]
    },
    {
      "code": "en",
      "language": "en",
      "files": [
        "/app/src/locales/en_US.json"
      ]
    },
    {
      "code": "es",
      "language": "es",
      "files": [
        "/app/src/locales/es_ES.json"
      ]
    },
    {
      "code": "zh-CN",
      "language": "zh-CN",
      "files": [
        "/app/src/locales/zh_CN.json"
      ]
    },
    {
      "code": "it",
      "language": "it",
      "files": [
        "/app/src/locales/it_IT.json"
      ]
    },
    {
      "code": "ru",
      "language": "ru",
      "files": [
        "/app/src/locales/ru_RU.json"
      ]
    },
    {
      "code": "vi",
      "language": "vi",
      "files": [
        "/app/src/locales/vi_VN.json"
      ]
    },
    {
      "code": "id",
      "language": "id",
      "files": [
        "/app/src/locales/id_ID.json"
      ]
    },
    {
      "code": "km",
      "language": "km",
      "files": [
        "/app/src/locales/km_KH.json"
      ]
    },
    {
      "code": "hi",
      "language": "hi",
      "files": [
        "/app/src/locales/hi_IN.json"
      ]
    },
    {
      "code": "th",
      "language": "th",
      "files": [
        "/app/src/locales/th_TH.json"
      ]
    },
    {
      "code": "fr",
      "language": "fr",
      "files": [
        "/app/src/locales/fr_FR.json"
      ]
    },
    {
      "code": "ar",
      "language": "ar",
      "files": [
        "/app/src/locales/ar_SA.json"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_and_default",
  "lazy": true,
  "langDir": "locales/",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "ko",
    "language": "ko",
    "files": [
      {
        "path": "/app/src/locales/ko_KR.json"
      }
    ]
  },
  {
    "code": "ja",
    "language": "ja",
    "files": [
      {
        "path": "/app/src/locales/ja_JP.json"
      }
    ]
  },
  {
    "code": "zh-hant",
    "language": "zh",
    "files": [
      {
        "path": "/app/src/locales/zh_TW.json"
      }
    ]
  },
  {
    "code": "en",
    "language": "en",
    "files": [
      {
        "path": "/app/src/locales/en_US.json"
      }
    ]
  },
  {
    "code": "es",
    "language": "es",
    "files": [
      {
        "path": "/app/src/locales/es_ES.json"
      }
    ]
  },
  {
    "code": "zh-CN",
    "language": "zh-CN",
    "files": [
      {
        "path": "/app/src/locales/zh_CN.json"
      }
    ]
  },
  {
    "code": "it",
    "language": "it",
    "files": [
      {
        "path": "/app/src/locales/it_IT.json"
      }
    ]
  },
  {
    "code": "ru",
    "language": "ru",
    "files": [
      {
        "path": "/app/src/locales/ru_RU.json"
      }
    ]
  },
  {
    "code": "vi",
    "language": "vi",
    "files": [
      {
        "path": "/app/src/locales/vi_VN.json"
      }
    ]
  },
  {
    "code": "id",
    "language": "id",
    "files": [
      {
        "path": "/app/src/locales/id_ID.json"
      }
    ]
  },
  {
    "code": "km",
    "language": "km",
    "files": [
      {
        "path": "/app/src/locales/km_KH.json"
      }
    ]
  },
  {
    "code": "hi",
    "language": "hi",
    "files": [
      {
        "path": "/app/src/locales/hi_IN.json"
      }
    ]
  },
  {
    "code": "th",
    "language": "th",
    "files": [
      {
        "path": "/app/src/locales/th_TH.json"
      }
    ]
  },
  {
    "code": "fr",
    "language": "fr",
    "files": [
      {
        "path": "/app/src/locales/fr_FR.json"
      }
    ]
  },
  {
    "code": "ar",
    "language": "ar",
    "files": [
      {
        "path": "/app/src/locales/ar_SA.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
